import { TRIAL_DAYS } from '../config/trial';

export function buildFAQSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: `${TRIAL_DAYS}日無料って本当?`,
        acceptedAnswer: {
          '@type': 'Answer',
          text: `はい。スタンダードプラン・カスタムプランを${TRIAL_DAYS}日間無料で試せます。合わなければ期間内に解約可能です。`,
        },
      },
      {
        '@type': 'Question',
        name: '通知はどこに届く?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Discordに届きます（スマホで受け取れます）。',
        },
      },
      {
        '@type': 'Question',
        name: 'なんでセカストが高いの?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'セカストは、他のサイトと比べて商品の更新量が多い仕入れ先です。せどりで勝つためには欠かせないサイトのため、より高度なスピード感で通知を提供しています。',
        },
      },
      {
        '@type': 'Question',
        name: '他のツールよりも通知が早い?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'はい。pacoは他の通知ツールと比べて通知スピードに強みがあり、新着商品をいち早くお届けします。2026年7月にはさらに通知速度を改善し、より早く新着商品を検知できるようになりました。',
        },
      },
      {
        '@type': 'Question',
        name: '途中で値上げされたらどうなる?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '途中で価格が変更となった場合も、限定価格でご契約いただいた方は解約するまで価格は変わりません。',
        },
      },
      {
        '@type': 'Question',
        name: '対応サイトは増える?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '随時、対応サイトは追加していきます。新しいサイトの通知ツールを追加する際は、公式LINE/Discordにて告知いたします。',
        },
      },
      {
        '@type': 'Question',
        name: '解約はいつでもできる?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'はい、いつでも解約可能です。違約金などは一切ありません。解約希望の場合は公式LINEよりご連絡ください。',
        },
      },
      {
        '@type': 'Question',
        name: 'Discordを使ったことがないのですが...',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Discordは無料で使えるチャットアプリです。スマホでもPCでも使えるため、通知をどこでも確認できます。Discordの登録方法はお申し込みいただいた後に、公式LINEよりご案内いたします。',
        },
      },
      {
        '@type': 'Question',
        name: '複数のサイトを同時に監視できる?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'カスタムプランで複数サイトを選択できます。必要なサイトだけを追加してください。',
        },
      },
    ],
  };
}

export function buildOrganizationSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'ForestCode',
    alternateName: 'reuse-paco',
    url: 'https://reuse-paco.com/',
    logo: 'https://reuse-paco.com/reuse-PACO_circle_icon.png',
    email: 'reuse.paco@gmail.com',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      url: 'https://lin.ee/ORf3l7j',
    },
  };
}

export function buildSoftwareApplicationSchema(): Record<string, unknown> {
  // Pricing.tsx:28-32 の sites 配列・価格定義と同じ値を使用
  // 価格変更時は Pricing.tsx と合わせて更新すること
  const BASE_PRICE = 980;
  const STANDARD_PRICE = 1980;
  const sites = [
    { price: 2000 },
    { price: 500 },
    { price: 500 },
  ];
  const maxCustomPrice = BASE_PRICE + sites.reduce((sum, s) => sum + s.price, 0);

  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'paco',
    alternateName: 'reuse-paco',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web, iOS, Android',
    description: `セカスト・トレファク等のリサイクルショップ新着商品をDiscordにリアルタイム通知するせどりサポートツール。他の通知ツールよりも高速な通知スピードが強み。2026年7月にさらに通知速度を改善。${TRIAL_DAYS}日間無料トライアルあり。`,
    url: 'https://reuse-paco.com/',
    featureList: [
      '他の通知ツールよりも高速な新着商品通知',
      '2026年7月の通知速度改善アップデート',
      'Discordへのリアルタイム通知',
    ],
    offers: [
      {
        '@type': 'Offer',
        name: 'スタンダードプラン',
        price: String(STANDARD_PRICE),
        priceCurrency: 'JPY',
        description: `セカスト特化プラン。${TRIAL_DAYS}日間無料トライアルあり。`,
      },
      {
        '@type': 'Offer',
        name: 'カスタムプラン',
        price: String(BASE_PRICE),
        priceCurrency: 'JPY',
        description: `基本料金${BASE_PRICE}円＋サイト追加料金。最大${maxCustomPrice}円/月（全サイト選択時）。${TRIAL_DAYS}日間無料トライアルあり。`,
      },
    ],
  };
}
